import moment from "moment";

angular
    .module("thor.core.dates.locale-date.filter", [])
    .filter("localeDate", [
        () => {
            const dateFilter = (date, format) => (date && format ? moment(date).format(format) : "");
            (dateFilter as any).$stateful = true;
            return dateFilter;
        }
    ])
    .filter("localeTime", [
        () => {
            const dateFilter = (date: string | Date) => {
                if (!date) {
                    return "";
                }
                date = new Date(date);
                return date.toLocaleTimeString(moment.locale(), {
                    hour: "2-digit",
                    minute: "2-digit",
                    second: date.getSeconds() !== 0 ? "2-digit" : undefined
                });
            };
            (dateFilter as any).$stateful = true;
            return dateFilter;
        }
    ]);
